const SINGLE_GPU_TASKS = new Set([
  "text-to-image",
  "text-to-video",
  "text-to-audio",
  "text-to-speech"
]);

export default class Model {
  constructor(makeMobxStore, _) {
    this._ = _;
    this.reset = makeMobxStore(this);
  }
  set = {
    clusterDoc: (clusterDoc = {}) => {
      this.clusterDoc = clusterDoc;
    },
    node: (node = {}) => {
      this.node = node;
    },
    readme: (readme = "") => {
      this.readme = readme;
    },
    json: (json = {}) => {
      this.json = json;
    },
    related: (related = []) => {
      this.related = related;
    },
    input: input => {
      this.input = input;
    },
    output: output => {
      this.output = output;
    },
    error: error => {
      this.error = error;
    },
    request: request => {
      this.request = request;
    },
    running: (running = false) => {
      this.running = running;
    }
  };
  getTier(ramRequired, tasks) {
    // for safety we have 1GB of extra overhead if we're either at the limits of what a single GPU
    // can handle, or what an instance's total VRAM can handle
    const bufferRoomGB = 1;

    let isSingleGPU = false;

    for (const task of tasks) {
      if (SINGLE_GPU_TASKS.has(task.name)) {
        isSingleGPU = true;
      }
    }

    if (isSingleGPU) {
      // L4s max memory per device is 24GB, hence bufferRoomGB
      return ramRequired <= 24 - bufferRoomGB ? "free" : "xl";
    }

    return ramRequired <= 24
      ? "free"
      : ramRequired <= 64
      ? "medium"
      : // g6.12xlarge's max memory for total instance is 96GB, hence bufferRoomGB
      ramRequired <= 96 - bufferRoomGB
      ? "large"
      : "xl";
  }

  get tier() {
    return this.getTier(this.node.minRequiredCpuRamGB, this.node.tasks);
  }
  get freeTier() {
    return this.tier === "free";
  }
  get paidTier() {
    return this.tier === "medium";
  }
  get xlTier() {
    return this.tier === "large";
  }
  get customTier() {
    return this.tier === "xl";
  }
  get notOnApiPlan() {
    return this._.user.plan?.startsWith("models-api") !== true;
  }
  get onFreeApiPlan() {
    return this._.user.plan === "models-api-free";
  }
  get onPaidApiPlan() {
    return this._.user.plan === "models-api-10";
  }
  get onScalePlan() {
    return this._.user.plan === "models-api-50";
  }
  get allowed() {
    return this.notOnApiPlan || this.customTier
      ? false
      : this.freeTier ||
          (this.paidTier && this.onFreeApiPlan === false) ||
          (this.xlTier && this.onScalePlan);
  }
  get needsUpgrade() {
    return (
      (this.onFreeApiPlan && this.freeTier === false) ||
      (this.xlTier && this.onScalePlan === false)
    );
  }
}
